import UserType from "@/domain/enums/UserType";
import Profile from "./Profile";
import Settings from "./Settings";
import StatusDetail from "./StatusDetail";

type UserProfileProps = {
    id: string;
    userId: string;
    tenantId: string | null;
    userType: UserType | string;
    profile: Profile;
    firstName: string;
    lastName: string;
    teamId: string | null;
    settings: Settings;
    monthlyAnalyzedMailCount: number;
    monthlySpentTokenCount: number;
    nextQuotaRenewalDate: string | null;
    isUserDisabled: boolean;
    isOnboardingDone: boolean;
    photoURL?: string;
    phoneNumber?: string;
    statusDetail: StatusDetail;
};

export default class UserProfile {
    id: string;

    userId: string;

    tenantId: string | null;

    userType: UserType | string;

    profile: Profile;

    firstName: string;

    lastName: string;

    teamId: string | null;

    settings: Settings;

    monthlyAnalyzedMailCount: number;

    monthlySpentTokenCount: number;

    nextQuotaRenewalDate: string | null;

    isUserDisabled: boolean;

    isOnboardingDone: boolean;

    photoURL?: string;

    phoneNumber?: string;

    statusDetail: StatusDetail;

    constructor({
        id,
        userId,
        tenantId,
        userType,
        firstName,
        lastName,
        profile,
        teamId,
        settings,
        monthlyAnalyzedMailCount,
        monthlySpentTokenCount,
        nextQuotaRenewalDate,
        isUserDisabled,
        isOnboardingDone,
        photoURL,
        phoneNumber,
        statusDetail,
    }: UserProfileProps) {
        this.id = id;
        this.userId = userId;
        this.tenantId = tenantId;
        this.userType = userType;
        this.firstName = firstName;
        this.lastName = lastName;
        this.profile = profile;
        this.teamId = teamId;
        this.settings = settings;
        this.monthlyAnalyzedMailCount = monthlyAnalyzedMailCount;
        this.monthlySpentTokenCount = monthlySpentTokenCount;
        this.nextQuotaRenewalDate = nextQuotaRenewalDate;
        this.isUserDisabled = isUserDisabled;
        this.isOnboardingDone = isOnboardingDone;
        this.photoURL = photoURL;
        this.phoneNumber = phoneNumber;
        this.statusDetail = statusDetail;
    }

    get getInitials(): string {
        return `${this.profile.displayName
            .split(" ")
            .map((n) => n[0])
            .join("")
            .slice(0, 2)}`;
    }
}
